import { render, staticRenderFns } from "./FileTable.vue?vue&type=template&id=ca181e82&scoped=true&"
import script from "./FileTable.vue?vue&type=script&lang=js&"
export * from "./FileTable.vue?vue&type=script&lang=js&"
import style0 from "./FileTable.vue?vue&type=style&index=0&id=ca181e82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca181e82",
  null
  
)

export default component.exports